(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    function stateConfig($stateProvider) {
        $stateProvider
            .state('social-integrations', {
                parent: 'admin',
                url: '/social-integrations',
                data: {
                    authorities: ['STORE_READ_CUSTOMER', 'SOCIAL_MEDIA_POST'],
                    pageTitle: 'integrations.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/integrations/integrations.html',
                        controller: 'BusinessIntegrationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('integrations');
                        $translatePartialLoader.addPart('checkout');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('social-media');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('customers');
                        return $translate.refresh();
                    }],
                }
            });
    }
})();
